import React, { useCallback, useEffect, useMemo, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Box, Divider, FormControl, Grid, List, ListItem, ListItemButton, ListItemText, Table, TableBody, TableCell, TableHead, TableRow, Typography, useTheme } from "@mui/material";
import Button from "../../common/Button";
import { useForm } from "react-hook-form";
import { AddCircleOutlineOutlined, Cancel, DeleteOutlineOutlined, EditOutlined } from "@mui/icons-material";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import BorderedSection from "../../common/BorderedSection";
import CustomNumberField from "../../common/CustomNumberField";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { tokens } from "../../../theme";
import { fetchProductItemsByProductId, fetchProductsByUserRoleData, useProductListReducer } from "../../../redux/slice/product/productListSlice";
import { deleterefProductbyproduciKitId, getProductItemkitItem, initialValuesOfProductkitItem, ProductkitItemInfo, savePoductKit, ProductKitCreateObj, ProductKitItemRequest } from "../../../redux/slice/product/createProductSlice";
import CustomTable from "../../common/CustomTable";
import CustomIconButton from "../../common/CustomIconButton";
import { useLocation, useNavigate } from "react-router-dom";
import {  setSingleAlertObj, SingleAlertInfo } from "../../../redux/slice/commonSlice";
import { OptionPopupObjectProps } from "../../common/OptionsPopup";
import { SUCCESS, PRODUCT_CATEGORY } from "../../../constants/applicationConstants";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import { useNavigation } from "../../../hooks/useNavigation";


interface ProductkitItemProps {
  open: boolean;
  onClose: () => void;

  productItemkitDetails: ProductkitItemInfo;
  isEdit: boolean;
  rowData: any;
  selectedProductManufacture:number;
}
interface ProductKit {
  product: productOption | null;
  grafts: GraftQty[] | undefined;
}

interface Row {
  graftsNeeded: string;
  productName?: string;
  qty?: string;
  id: number;
  usageType?: string;	//CS-1544
};

type Option = {
  value: string | number;
  label: string;
};


type productOption = {
  value: string | number,
  label: string,
  productId: string | undefined
};

export type GraftQty = {
  productItemId: number,
  quantity: number,
  graftsNeeded: string,
  productName:string|null
  usageType?:string		//CS-1544
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AddProductKitPopup: React.FC<ProductkitItemProps> = ({
  open,
  onClose,
  rowData,
  productItemkitDetails,
  isEdit,
  selectedProductManufacture,
}) => {

  const [selectedProduct, setSelectedProduct] = useState<productOption | null>();
  const [graftsQtyList, setGraftsQtyList] = useState<GraftQty[]>();
  const [showpoductkilist, setshowpoductkilist] = useState<ProductKit>({
    product: null,
    grafts: [],
  });
  const location = useLocation();
  const { state } = location;
  const [listData, setListData] = useState<Row[]>([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useAppDispatch();
  const { control, handleSubmit, reset } = useForm<ProductkitItemInfo>({ defaultValues: initialValuesOfProductkitItem });
  const { productsByUserRole } = useProductListReducer();
  const [productItemRows, setProductItemRows] = useState<any[]>([]);
  const { navigate } = useNavigation();
  const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: "", show: false });
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    dispatch(fetchProductsByUserRoleData(true));

  }, []);

  useEffect(() => {
    const fetchProductItemKitData = async () => {
      if (rowData?.productItemId) {
        try {
          const productItemId = rowData.productItemId;
          const response = await dispatch(getProductItemkitItem({ productItemId, skipLoader: false }))

          const items = response?.payload?.data;
          if (items && Array.isArray(items)) {
            const data = items.map((item) => ({
              productItemKitItemId: item.productItemKitItemId,
              refProductId: item.refProductId,
              product: item.productName,
              productName: `${item.productItemDescription} ${item.size} (${item.productItemHcpcsCode})`,
              graftQty: item.qty || 0,
              ProductItemSize: item.size || "N/A",
              usageType: item.kitItemUsageType || "N/A",	//CS-1544
            }));
            
            //CS-1544 START
            const sortedData = data.sort((a, b) => {
              if (a.usageType === "Primary") return -1;
              if (b.usageType === "Primary") return 1;
              if (a.usageType === "Secondary") return -1;
              if (b.usageType === "Secondary") return 1;
              return 0;
            });
            
            setProductItemRows(sortedData);
            //CS-1544 END
          }
        } catch (error) {
          console.error("Error fetching product item kit data:", error);
        }
      }
    };

    fetchProductItemKitData();
  }, [dispatch, rowData]);


  useEffect(() => {
    if (open) {
      if (!isEdit) {
        setSelectedProduct(null);
        setGraftsQtyList([]);
        reset();
      } else {
        reset(productItemkitDetails);
      }
    }

    if (!open) {
      // If closing, clear the state for the next time
      setDefaultValues();
    }
  }, [open, productItemkitDetails, reset]);

  const setDefaultValues = useCallback(() => {
    reset();
  }, []);

  const onSubmit = async (data: ProductKitCreateObj) => {
    const formattedData = productItemRows
      .map((item: any) => ({
        productItemId: rowData.productItemId,
        refProductId: item.refProductId,
        refProductItemId: item.refProductItem,
        qty: item.graftQty || 0,
      }))
      .filter((item: any) => item.qty > 0 && item.refProductItemId);
    try {

      const response = await dispatch(savePoductKit(formattedData));

      if (response.payload?.code === SUCCESS_CODE && response.payload?.message === SUCCESS) {
        onClose();
        const alertObj: SingleAlertInfo = {
          message: "Product Kit Created sucessfully!",
          alertType: "success",
        };
        dispatch(setSingleAlertObj(alertObj));
      }
      else {
        const alertObj: SingleAlertInfo = {
          message: response.payload?.message || "Cration failed!",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(alertObj));
      }
    } catch (error) {

    } finally {
      cancelOptionPopup();
    }
  };

  const cancelOptionPopup = () => {
    setShowOptionsPopup({ message: "", show: false });
  };


  const handleDeleteAction = async (productItemKitItemId?: number, rowIndex?: number) => {
    try {
      if (productItemKitItemId !== undefined) {

        const response = await dispatch(deleterefProductbyproduciKitId(productItemKitItemId));

        if (response.payload && response.payload.message === "SUCCESS") {
          dispatch(setSingleAlertObj({
            title: "Success",
            message: "The Product Kit Item Deleted successfully.",
            alertType: "success",
          }));

          setProductItemRows((prevRows) => prevRows.filter(row => row.productItemKitItemId !== productItemKitItemId));

        }
      } else if (rowIndex !== undefined) {

        setProductItemRows((prevRows) => {
          const updatedRows = [...prevRows];
          updatedRows.splice(rowIndex, 1);
          return updatedRows;
        });

        dispatch(setSingleAlertObj({
          title: "Success",
          message: "The Product Kit Item Deleted successfully.",
          alertType: "success",
        }));
      } else {

        console.log("No valid ID or row index provided for delete operation.");
      }
    } catch (error) {
      console.error("Error during delete operation:", error);
    }
  };




  const productItemByIdConsignmentOrder = async (selectedProductId: any) => {
    const onlyActiveRecords = true;
    const response = await dispatch(fetchProductItemsByProductId({ productId: selectedProductId, onlyActiveRecords }));
    if (response.meta.requestStatus === 'fulfilled') {
      return response.payload;
    };
  };
  useEffect(() => {

    if (selectedProduct) {
      productItemByIdConsignmentOrder(selectedProduct.value).then((data) => {
        setListData(() => {
          const newValues = [...(data || [])]
            .sort(
              (
                a: { size: string; productItemId: number; units: number ,productItemDescription:string,hcpcsCode:string },
                b: { size: string; productItemId: number; units: number ,productItemDescription:string,hcpcsCode:string }
              ) => a.units - b.units
            )
            .map((productItem: { size: string; productItemId: number ,productItemDescription:string,hcpcsCode:string, usageType?: string }) => ({
              graftsNeeded: productItem.size,
              productName: `${productItem.productItemDescription} ${productItem.size} (${productItem.hcpcsCode})`,
              id: productItem.productItemId,
              usageType: productItem.usageType || "N/A"	//CS-1544
            }));
          return newValues;
        });
      });
    }
  }, [selectedProduct]);


      const handleChange = (name: string, value: string) => {
        const selectProduct = productsByUserRole?.find(prod => prod.productId === value);
        if (selectProduct) {
          setSelectedProduct({
            label: selectProduct.productName,
            value: selectProduct.productId,
            productId: selectProduct.productId
          });
        }

        setGraftsQtyList([]);
      };

        const columnsItem = useMemo(() => [
          {
            id: "product",
            label: "Product Name",
            minWidth: 150,
          },
          {
            id: "graftQty",
            label: "Qty",
            minWidth: 100,
          },
          //CS-1544
          {
            id: "usageType",
            label: "Usage Type",
            minWidth: 100,
          },
          {
            id: "action",
            label: "Action",
            minWidth: 150,
          },
        ], []);

       const productOptions: Option[] = useMemo(() => {
        return productsByUserRole
          ?.filter((prod: any) => {
            return prod.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && prod.isKit === false && selectedProductManufacture === prod.manufacturerId;
          })
          .map((prod: any) => ({
            label: prod.productName,
            value: prod.productId,
            productId: prod.productId,
          })) || [];
      }, [productsByUserRole, selectedProductManufacture]);

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>, values?: any) => {
    const { name, value } = event.target;
    const idString = name.split('.')[1];
    const id = parseInt(idString, 10);

    if (isNaN(id)) {
      console.error("Invalid productItemId. Cannot parse to number.", idString);
      return;
    }

    const row = listData.find((r) => r.id === id);

    if (row) {

      // Update graftQtyList with new quantity for the selected graft
      setGraftsQtyList((prevValues) => {
        let updatedValues = prevValues ? [...prevValues] : [];

        updatedValues = updatedValues.filter((prev) => prev.productItemId !== id);

        if (value !== '') {
          let graft: GraftQty = {
            productItemId: id,
            graftsNeeded: row.graftsNeeded,
            productName: row.productName || null,
            quantity: values?.floatValue || parseInt(value, 10),
            usageType: row.usageType || "N/A"	//CS-1544
          };
          updatedValues.push(graft);
        }
        return updatedValues;
      });

    }
  };

  const closeComponentMainRow = (productItemKitItemId: number, rowIndex: number): JSX.Element => {
    return (
      <FormControl>
        <CustomIconButton
          color="error"
          size="medium"
          variant="outlined"
          tooltipMessage="Delete"
          tooltipPlacement="bottom"
          onClick={() => handleDeleteAction(productItemKitItemId, rowIndex)}
        >
          <DeleteOutlineOutlined fontSize="small" />
        </CustomIconButton>
      </FormControl>
    );
  };


  const handleAddItem = () => {

    if (!selectedProduct) {
      dispatch(
        setSingleAlertObj({
          message: "Please select a product, before Add Item.",
          alertType: "error",
        })
      );
      return;
    }

    if (!graftsQtyList || graftsQtyList.length === 0) {
      dispatch(
        setSingleAlertObj({
          message: "Please enter quantities for the selected product.",
          alertType: "error",
        })
      );
      return;
    }
    // Map new items from graftsQtyList
    const newItems = graftsQtyList.map((graft) => ({
      product: selectedProduct.label,
      refProductId: selectedProduct.productId,
      refProductItem: graft.productItemId,
      graftQty: graft.quantity || 0,
      ProductItemSize: graft.graftsNeeded,
      productName: graft.productName,
      productId: selectedProduct.value,
      usageType: graft.usageType || "N/A"	//CS-1544
    }));


    const combinedItems = [...productItemRows];


    
    const duplicateItems = newItems.filter((newItem) =>
      combinedItems.some(
        (row) =>
          row.refProductId === newItem.refProductId &&
          row.ProductItemSize === newItem.ProductItemSize
      )
    );
  
    if (duplicateItems.length > 0) {
      dispatch(
        setSingleAlertObj({
          message: "This product for same size already exist.",
          alertType: "error",
        })
      );
      return;
    }


    const validItems = newItems.filter((item) => item.graftQty > 0);

    if (validItems.length === 0) {
      dispatch(
        setSingleAlertObj({
          message: "Please provide valid quantities for at least one product.",
          alertType: "error",
        })
      );
      return;
    }
    if (validItems.length > 0) {
      dispatch(
        setSingleAlertObj({
          message: "Item Added Successfully",
          alertType: "success",
        })
      );
    }
   
    setProductItemRows((prevRows) => {
      const newRows = [...prevRows, ...validItems];
      // CS-1544
      return newRows.sort((a, b) => {
        if (a.usageType === "Primary") return -1;
        if (b.usageType === "Primary") return 1;
        if (a.usageType === "Secondary") return -1;
        if (b.usageType === "Secondary") return 1;
        return 0;
      });
    });
    
    reset();
    setSelectedProduct(null);
    setListData([]);
    setGraftsQtyList([]);
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        onClick={(event) => {
          event.stopPropagation();
        }}
        maxWidth="lg"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>
            Manage Product Kit Item ({rowData?.productItemDescription ? (rowData?.productItemDescription):""})
          </DialogTitle>
          <Divider orientation="horizontal" variant="fullWidth" flexItem />
          <DialogContent>
            <Box mt={3}>
              <Grid container spacing={2} mt={1} >
                <Grid item md={12} xs={12}>
                  <CustomDropdownField
                    name="productId"
                    control={control}
                    onChangeSelect={(name, value) => handleChange(name, value)}
                    options={productOptions}

                    label="Product"
                  />
                </Grid>
              </Grid>


              <Grid container spacing={2} mb={2}>
                <Grid item xs={12} md={12}>
                  {listData.length !== 0 && (
                    <List sx={{ bgcolor: colors.grey[900], borderRadius: 3 }}>

                      <ListItem>
                        <ListItemButton
                          onClick={() => { }}
                          sx={{ padding: 1, borderRadius: 2, fontSize: 14 }}
                        >

                          <ListItemText sx={{ width: "60%" }}>
                            <b>Product</b>
                          </ListItemText>
                          <Typography sx={{ width: "60%" }}>
                            <b>QTY</b>
                          </Typography>
                        </ListItemButton>
                      </ListItem>

                      {listData?.map((row) => (
                        <ListItem key={row.id}>
                          <ListItemButton onClick={() => { }} sx={{ padding: 0, borderRadius: 2 }}>
                            <ListItemText sx={{ width: "30%" }} className="ProductItemSize">
                              {row.productName}
                            </ListItemText>
                            <CustomNumberField
                              control={control}
                              controllerName={`graftQty.${row.id}`}
                              onChange={handleQuantityChange}
                              rules={{ min: { value: 1, message: "Minimum value allowed is 1" } }}
                              label="QTY"
                              sx={{ width: "50%" }}
                              allowDecimal={false}
                              allowNegative={false}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  )}
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    sx={{ borderRadius: 1, boxShadow: 1, mb: 1, p: 1 }}
                    spacing={1}
                  >
                    <Grid item md={"auto"} textAlign={"end"} alignItems="center" xs={12}>
                      <Button
                        color="info"
                        startIcon={<AddCircleOutlineOutlined />}
                        onClick={handleAddItem}
                        fullWidth
                      >
                        Add Item
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ borderRadius: 1, boxShadow: 1, mb: 1, p: 1 }}
                spacing={1}
              >
              </Grid>

            </Box>
            <Box mt={3}>
              <BorderedSection title="Product Kit Items"  >
                <Table
                  style={{ background: disabled ? theme.palette.mode === "dark" ? "#383838" : "#FFFFFF" : colors.grey[800] }}
                >
                  <TableHead>
                    <TableRow>
                      {columnsItem.map((column) => (
                        <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
                          <Typography
                            fontWeight="bold"
                            color={
                              disabled
                                ? "#898989"
                                : theme.palette.mode === "dark"
                                  ? colors.info[300]
                                  : colors.grey[500]
                            }
                            sx={{
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {column.label}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productItemRows.map((row: any, index: number) => (
                      <TableRow key={row.productItemKitItemId}>
                        <TableCell>{row.productName}</TableCell>
                        <TableCell>{row.graftQty}</TableCell>
                        <TableCell>{row.usageType}</TableCell>
                        <TableCell>{closeComponentMainRow(row.productItemKitItemId, index)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>

                </Table>
              </BorderedSection>
            </Box>
          </DialogContent>
          <Divider orientation="horizontal" variant="fullWidth" flexItem />
          <DialogActions>
            <Grid
              container
              justifyContent={{ xs: "center", md: "flex-end" }}
              spacing={2}
            >
              <Grid item xs={12} md="auto">
                <Button type="submit" startIcon={<EditOutlined />} fullWidth>
                  Add Product Item In Kit
                </Button>
              </Grid>
              <Grid item xs={12} md="auto">
                <Button
                  color="error"
                  onClick={onClose}
                  startIcon={<Cancel />}
                  fullWidth
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default AddProductKitPopup;
